export default __webpack_public_path__ + "static/media/image_thirdReview.e273fe88.jpg";